// JavaScript Document
/*---------------------------------------------
	header menu
---------------------------------------------*/
$(function(){
	var header = $('header');
	var headerHeight = header.outerHeight();
	var headerBth = $('.menu-trigger');
	headerBth.on("click",function(){//if menu btn click
		var w = window.innerWidth;
		var x =1080;
		var y = $(window).height() + 100; 
		if (w <= x) {//if smart phone
			header.toggleClass('active');
			$('.overlay').fadeToggle(200);
			$('.overlay').click(function(){
				header.removeClass('active');
				$('.overlay').fadeOut(200);
			 });
			 $('.headNav_gMenu').css('height',y+'px');
		}
	});
	$(window).on("scroll",function(){
		if(header.hasClass('active') && header.hasClass('scroll')){
			header.removeClass('active');
			$('.overlay').fadeOut(200);
		}
	});
    $(window).on("resize",function(){
		$('.headNav_gMenu').attr('style', '');
	});
});

